
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function MissionsPage() {
  const missionAreas = [
    {
      title: 'Rural Evangelism',
      description: 'Reaching remote communities with the Gospel of Christ',
      icon: 'ri-map-pin-line'
    },
    {
      title: 'Church Planting',
      description: 'Establishing new Ecclesia centers in unreached territories',
      icon: 'ri-building-line'
    },
    {
      title: 'Missionary Training',
      description: 'Equipping firebrands for effective ministry in dry lands',
      icon: 'ri-graduation-cap-line'
    },
    {
      title: 'Unreached Peoples',
      description: 'Targeting communities without Gospel witness',
      icon: 'ri-earth-line'
    }
  ];

  const testimonials = [
    {
      name: 'Pastor Samuel Okafor',
      location: 'Northern Nigeria',
      testimony: 'Through Root and Reign Mission, we planted 15 CFN centers in rural communities. The transformation has been remarkable.',
      image: 'https://readdy.ai/api/search-image?query=African%20pastor%20in%20rural%20setting%20with%20simple%20background%2C%20warm%20lighting%2C%20professional%20portrait%20style%2C%20ministry%20context&width=300&height=300&seq=mission1&orientation=squarish'
    },
    {
      name: 'Evangelist Mary Adebayo',
      location: 'Chad Republic',
      testimony: 'The missionary training equipped me to reach the unreached. God is moving powerfully in the villages.',
      image: 'https://readdy.ai/api/search-image?query=African%20female%20evangelist%20in%20rural%20mission%20field%2C%20simple%20background%2C%20warm%20lighting%2C%20professional%20portrait%20style%2C%20ministry%20context&width=300&height=300&seq=mission2&orientation=squarish'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section 
        className="relative py-32 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(184, 20, 74, 0.8), rgba(184, 20, 74, 0.8)), url('https://readdy.ai/api/search-image?query=Rural%20African%20landscape%20with%20scattered%20villages%20and%20farmland%2C%20golden%20hour%20lighting%2C%20vast%20open%20spaces%2C%20simple%20traditional%20huts%2C%20peaceful%20countryside%20setting%2C%20warm%20earth%20tones%2C%20missionary%20outreach%20context&width=1920&height=800&seq=missionhero&orientation=landscape')`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h1 className="text-5xl font-bold mb-6">Root and Reign Mission</h1>
          <p className="text-xl max-w-4xl mx-auto mb-8">
            Raising firebrands in dry lands - Reaching rural and unreached peoples with the transforming power of Christ
          </p>
          <Link 
            to="/join"
            className="bg-white text-[#b8144a] px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            Join the Mission
          </Link>
        </div>
      </section>

      {/* Mission Overview */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Our Mission Focus</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Root and Reign Mission is the rural and unreached people mission arm of PAAM, 
              dedicated to raising firebrands in dry lands and establishing the Kingdom in remote territories.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {missionAreas.map((area, index) => (
              <div key={index} className="text-center">
                <div className="w-20 h-20 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${area.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{area.title}</h3>
                <p className="text-gray-700">{area.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mission Strategy */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Mission Strategy</h2>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-[#b8144a] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Identify Unreached Areas</h3>
                    <p className="text-gray-700">Strategic mapping and research to locate communities without Gospel witness</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-[#b8144a] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Train Local Missionaries</h3>
                    <p className="text-gray-700">Equipping indigenous believers to reach their own communities effectively</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-[#b8144a] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Establish CFN Centers</h3>
                    <p className="text-gray-700">Planting Christ Family Network centers for ongoing discipleship and growth</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-[#b8144a] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Sustainable Development</h3>
                    <p className="text-gray-700">Creating self-sustaining ministry structures that continue to grow and multiply</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=African%20missionaries%20training%20in%20rural%20setting%2C%20outdoor%20Bible%20study%2C%20simple%20background%2C%20warm%20lighting%2C%20community%20gathering%2C%20ministry%20training%20context%2C%20authentic%20documentary%20style&width=600&height=400&seq=missionstrategy&orientation=landscape"
                alt="Mission Strategy"
                className="rounded-lg shadow-lg object-cover w-full h-96"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Mission Impact</h2>
            <p className="text-xl text-gray-600">Testimonies from the field</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-gray-50 p-8 rounded-lg shadow-lg">
                <div className="flex items-center mb-6">
                  <img 
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full object-cover mr-4"
                  />
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900">{testimonial.name}</h3>
                    <p className="text-[#b8144a] font-medium">{testimonial.location}</p>
                  </div>
                </div>
                <p className="text-gray-700 italic">"{testimonial.testimony}"</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-[#b8144a] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">Answer the Call to the Harvest</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Join Root and Reign Mission and become part of God's strategy to reach every rural community 
            and unreached people group with the Gospel of Christ.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/join"
              className="bg-white text-[#b8144a] px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Become a Missionary
            </Link>
            <Link 
              to="/training"
              className="border-2 border-white text-white px-8 py-3 rounded-full font-semibold hover:bg-white hover:text-[#b8144a] transition-colors whitespace-nowrap cursor-pointer"
            >
              Mission Training
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
